import { FormControl, FormGroup } from '@angular/forms';
import { addError, removeError } from '@core/utils/error-functions';
import moment from 'moment';

export class DateIntervalValidation {
  static validate({
    from,
    to,
    maxDiffLte,
    unit
  }: {
    from: string,
    to: string,
    maxDiffLte: moment.DurationInputArg1,
    unit: moment.DurationInputArg2
  }): any {
    return (formGroup: FormGroup) => {
      const fromControl = formGroup.controls[from] as FormControl;
      const toControl = formGroup.controls[to] as FormControl;

      if (!fromControl.value || !toControl.value || !fromControl.value.isValid() || !toControl.value.isValid()) {
        return null;
      }

      const diff = toControl.value.diff(fromControl.value, unit, true);
      if (diff > maxDiffLte) {
        addError(fromControl, 'invalidRange');
        addError(toControl, 'invalidRange');
      } else {
        removeError(fromControl, 'invalidRange');
        removeError(toControl, 'invalidRange');
      }

      return null;
    };
  }
}
